<div class="dialogo">
    <h1 mat-dialog-title class="titulo">Eliminar destinatario</h1>
    <div mat-dialog-content>
        <p *ngIf="!finalizado" >{{"Seguro que desea eliminar el destinatario"}}</p>
        <p *ngIf="!finalizado" ><b>{{data.titulo + "?"}}</b></p>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="error">
            <span class="error">{{mensaje}}</span>
        </div>
        <div class="mensajeEliminar"  *ngIf="menuList.length > 0 && !finalizado" >
            <span >Este destinatario está vinculado a los menú siguientes</span>
            <mat-list>
                <mat-list-item  *ngFor="let menu of menuList">
                    <mat-icon mat-list-icon class="waiting">warning</mat-icon>
                    <h4 mat-line>{{menu}}</h4>
                </mat-list-item>
            </mat-list>
        </div>
        <div class="mensajeEliminar" style="padding-bottom: 15px; padding-top: 15px;" *ngIf="finalizado">
            <span ><mat-icon mat-list-icon class="waiting">warning</mat-icon> El destinatario <b>{{data.titulo}}</b> fue eliminado correctamente</span>
        </div>
    </div>
    <div mat-dialog-actions>
            <span class="padding-right-10" *ngIf="!finalizado">
                <button mat-raised-button  (click)="deleteDestinatario()" color="warn" style="padding-bottom: 5px; padding-top: 5px;margin-right: 10px;"
                        cdkFocusInitial>
                    Eliminar
                    <mat-icon >delete</mat-icon>
                </button>
            </span>
        
            <span class="padding-right-10" *ngIf="!finalizado">
                <button mat-raised-button  style="padding-bottom: 5px; padding-top: 5px;" (click)="cancelar()">
                    Cancelar
                    <mat-icon >cancel</mat-icon>
                </button>
            </span>
            <span class="padding-right-10" *ngIf="finalizado">
                <button mat-raised-button color="primary" [mat-dialog-close]="true" style="padding-bottom: 5px; padding-top: 5px;" (click)="aceptar()">
                    Aceptar
                </button>
            </span>
    </div>
</div>

